import { createAsyncThunk } from "@reduxjs/toolkit";

import { BAND_ACTIONS, FlightPrefillFields } from "Bands/types";
import {
  API_ENDPOINTS,
  extractFlightNumberFromFlightPrefillFields,
} from "shared/constants";
import { APIService } from "shared/services";

export const prefillFlight = createAsyncThunk(
  BAND_ACTIONS.fetchPrefillFlight,
  async (data: FlightPrefillFields, { rejectWithValue }) => {
    try {
      const prefillData = await APIService.get({
        path: API_ENDPOINTS.SCHEDULED_FLIGHTS,
        data: extractFlightNumberFromFlightPrefillFields(data),
      });

      return prefillData;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
